export const presignMessagePrefix = '\x19Ethereum Signed Message:\n'
